import { PortalEnvironment } from './environments';
import { FAMILY_NAV } from './family-nav';
import './family.generated.css';

/**
 * The family console, as configuration.
 *
 * Blue rather than violet, `.shell / .top / .side` chrome rather than the
 * educator portal's, and a nav whose labels sit in `.lb`. Everything else —
 * the account menu, how an item knows it is current, sign-out — comes from the
 * shared chrome.
 */
export const FAMILY_ENVIRONMENT: PortalEnvironment = {
  scope: 'env-family',
  chrome: 'console',
  navLabelClass: 'lb',
  badge: 'Family',
  home: '/parent/dashboard',
  nav: FAMILY_NAV,
  accountLinks: [
    { label: 'Perfil', to: '/profile' },
    { label: 'Ajustes', to: '/settings' },
    { label: 'Explorar clases', to: '/parent/explore' },
    { label: 'Centro de ayuda', to: '/help' },
  ],
};
